// extracted by mini-css-extract-plugin
export var addWidgetButton = "_u-6";
export var backButton = "_u-1";
export var legacyWidgetContainer = "_u-5";
export var pageContainer = "_u-2";
export var settingsContent = "_u-0";
export var widgetSubsectionItem = "_u-3";
export var widgetSubsectionItemContent = "_u-4";